import React from 'react'
import { Tile } from '../../../shared/webcomponents/react-wrappers/Tile'
import { getRelativeTimeMessage } from '../../../shared/lib/relativeTimeMessage.no-deps'
import type { AiChatFileSource } from '../../../shared/domain/aiChats/types.no-deps'
import { FileExtensionIcon } from '../ui/FileExtensionIcon'
import i18next from 'i18next'
import type { BaseSourceProps } from './ZapBot'

type Props = BaseSourceProps & {
    source: AiChatFileSource
    onClick: () => void
}

export function ChatFileSource({ source, deps, number, onClick }: Props) {
    const pagesTypeLabel =
        source.file.extension === '.pptx' ? i18next.t('appcore:ZapBot.slides') : i18next.t('appcore:ZapBot.pages')

    return (
        <Tile
            title={source.file.fileName}
            number={number}
            onClick={() => onClick()}
            subtitle={getRelativeTimeMessage(deps.locale, source.file.createdAt, new Date())}
        >
            <div className="ZapBot_report-source-icon" slot="icon">
                <FileExtensionIcon fileExtension={source.file.extension} isGrayscale={false} />
            </div>

            {source?.pages?.length ? (
                <span className="ZapBot_source-pages" slot="parentInfo">
                    {pagesTypeLabel}: {source.pages.map(({ label, number }) => label || number).join(', ')}
                </span>
            ) : null}
        </Tile>
    )
}
